import { makeStyles, Typography } from "@material-ui/core";
import { useSelector } from "react-redux";

import { InfoBox } from "../../../../components/boxes/InfoBox";
import { BarChart } from "../../../../components/charts/BarChart";
import { Box } from "../Box";
import { GroupButton } from "../GroupButton";
import { Header } from "../Header";
import { consumptionData } from "../sample";

const useStyles = makeStyles((theme) => ({
  chartTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(3.5),
  },
}));

export const VacancyRate = ({ building, onClose }) => {
  const classes = useStyles();
  const currencySymbol = useSelector((state) => state.auth.user.currency.symbol);

  return (
    <Box>
      <Header building={building} title="High Vacancy Rate" onClose={onClose} />
      <InfoBox color="#FFE6E6">
        <Typography variant="h4">
          <Typography variant="h4" style={{ color: "red", display: "inline" }}>
            32% Vacancy rate.{" "}
          </Typography>
          Power consumption dropped in the last 3 months. Power revenue loss:
          {currencySymbol}680/month
        </Typography>
      </InfoBox>
      <Typography className={classes.chartTitle}>Consumption over the last 12 months</Typography>
      <BarChart height={120} barSize={10} chartData={consumptionData} />
      <GroupButton
        buttons={[{ text: "SHARE" }, { text: "SHOW REPORT" }, { text: "EXPORT SAME TYPE ALERTS" }]}
      />
    </Box>
  );
};
